// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__uGy9T","modalForm":"UpgradeEpcsModal_modalForm__28_9g","modalFooter":"UpgradeEpcsModal_modalFooter__390nG"};